/* @flow */
export const CONSTELLATION_RESULTS_LIMIT = 500;

export const graphEndpoint = () => '/services/graph';

export const queryRecordParams = {
  limit: 500,
  type: 'RECORD',
};

export const queryIndicatorParams = {
  limit: 500,
  type: 'INDICATOR',
};



// WEBPACK FOOTER //
// ./src/app/modules/constellation/constants.js